<script lang="ts">
    import { ExclamationCircleOutline } from "flowbite-svelte-icons";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";

    let {isOpen = $bindable(), reset, close}: {
        isOpen: boolean,
        reset: () => void,
        close: () => void
    } = $props();

</script>

<ColoredModal autoclose bind:open={isOpen} size="xs">
    <div class="text-center">
        <ExclamationCircleOutline class="mx-auto mb-4 w-12 h-12"/>
        <h3 class="mb-5 text-lg font-normal">Are you sure you want to reset the
            counter and checklist?</h3>
        <ColoredButton class="me-2" color="red" onclick={reset}>Yes, I'm sure</ColoredButton>
        <ColoredButton color="teal" onclick={close}>No, cancel</ColoredButton>
    </div>
</ColoredModal>
